// SelectedSummary.jsx
import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";
import { SelectedSummaryRoot } from "./SelectedSummary.styles";

const currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const SelectedSummary = ({ onHandleToggle, showInterface }) => {
  const { subtotal, openSummary } = useSelectedOptions();
  const theme = useTheme();

  return (
    <SelectedSummaryRoot>
      <Button
        sx={{
          color: theme?.palette?.companyColors?.secondary,
          background: theme?.palette?.companyColors?.accent,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          borderRadius: theme?.borderRadius?.small,
          boxShadow: "0px 0px 5px rgba(0,0,0,0.25)",
          padding: { xs: "0.9rem 1.5rem", lg: "1rem 1.5rem", xl: "1rem 2rem" },
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            background: theme?.palette?.companyColors?.secondary,
            color: theme?.palette?.companyColors?.accent,
          },
        }}
        onClick={() => {
          openSummary();
        }}
      >
        <Typography
          variant="button"
          sx={{
            textTransform: "initial",
            fontSize: { xs: "1.5rem", xl: "1.65rem" },
            fontWeight: 400,
          }}
        >
          View summary
        </Typography>
      </Button>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: theme?.palette?.companyColors?.primary,
          }}
        >
          Price
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 800,
            letterSpacing: "-1px",
            fontSize: { xs: "2rem", lg: "1.75rem", xl: "2.25rem" },
            fontFamily: "Onest",
            color: theme?.palette?.companyColors?.darkGrey,
          }}
        >
          {currency.format(subtotal)}
        </Typography>
      </Box>
    </SelectedSummaryRoot>
  );
};
